import { FetchPolicy, MutationFetchPolicy, WatchQueryFetchPolicy } from "@apollo/client/core/watchQueryOptions"

// Apollo fetch policies for the whole app. Kept in their own module: they used to live in DashboardLayout, so every
// hook that read one pulled the dashboard (and through it pdf.js) into the first download of every page.

// TODO: change globalFetchPolicy to watchQueryFetchPolicy for queries and globalMutationsFetchPolicy for mutations
export const globalFetchPolicy: FetchPolicy = "no-cache"
export const watchQueryFetchPolicy: WatchQueryFetchPolicy = "cache-and-network"
export const globalMutationsFetchPolicy: MutationFetchPolicy = "network-only"
